/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Energy_CertificateInputs */

const cs_enum_energy_certificate = /** @type {(inputs: Enum_Energy_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PENB`)
};

const en_enum_energy_certificate = /** @type {(inputs: Enum_Energy_CertificateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Energy certificate`)
};

/**
* | output |
* | --- |
* | "Energy certificate" |
*
* @param {Enum_Energy_CertificateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_energy_certificate = /** @type {((inputs?: Enum_Energy_CertificateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Energy_CertificateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_energy_certificate(inputs)
	return cs_enum_energy_certificate(inputs)
});